import { render, staticRenderFns } from "./sms-verification.vue?vue&type=template&id=2b5667ae&scoped=true"
import script from "./sms-verification.vue?vue&type=script&lang=js"
export * from "./sms-verification.vue?vue&type=script&lang=js"
import style0 from "./sms-verification.vue?vue&type=style&index=0&id=2b5667ae&prod&lang=css"
import style1 from "./sms-verification.vue?vue&type=style&index=1&id=2b5667ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5667ae",
  null
  
)

export default component.exports